var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"position":"fixed","height":"100%"},attrs:{"cols":"2"}},[_c('CourseSidebar')],1),_c('v-spacer'),_c('v-col',{attrs:{"cols":"10"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }